import type { ButtonNode, MenuNode, MenuSchema, TextInputNode, TextNode } from '../MenuSchema.js';

export const VR_MAIN_MENU_ACTIONS = {
    chooseScreenshare: 'choose-screenshare-media',
    chooseCamerashare: 'choose-camerashare-media',
    toggleBroadcast: 'vr-toggle-broadcast-media',
    broadcastUrl: 'broadcast-url-media',
    toggleServerBroadcast: 'vr-toggle-server-broadcast',
    audioMixDown: 'vr-audio-mix-down',
    audioMixUp: 'vr-audio-mix-up',
    toggleResync: 'vr-toggle-url-resync',
} as const;

export function createVrMainMenuSchema(): MenuSchema {
    return {
        id: 'MAIN',
        title: 'Video Sharing',
        nodes: [
            {
                type: 'text',
                text: 'Choose a source, then broadcast it or play a direct URL.',
            },
            {
                type: 'button',
                id: VR_MAIN_MENU_ACTIONS.chooseScreenshare,
                label: 'Screen',
            },
            {
                type: 'button',
                id: VR_MAIN_MENU_ACTIONS.chooseCamerashare,
                label: 'Camera',
                platforms: ['web'],
            },
            {
                type: 'button',
                id: VR_MAIN_MENU_ACTIONS.toggleBroadcast,
                label: 'Broadcast',
            },
            {
                type: 'input',
                id: 'vr-broadcast-url-input',
                placeholder: 'https://example.com/video-stream.mp4',
                get: () => '',
                inputType: 'text',
            },
            {
                type: 'button',
                id: VR_MAIN_MENU_ACTIONS.broadcastUrl,
                label: 'Play URL For Everyone',
            },
            {
                type: 'button',
                id: VR_MAIN_MENU_ACTIONS.toggleServerBroadcast,
                label: 'Server Broadcast: Off',
            },
            {
                type: 'button',
                id: VR_MAIN_MENU_ACTIONS.audioMixDown,
                label: 'Audio -',
            },
            {
                type: 'button',
                id: VR_MAIN_MENU_ACTIONS.audioMixUp,
                label: 'Audio +',
            },
            {
                type: 'button',
                id: VR_MAIN_MENU_ACTIONS.toggleResync,
                label: 'URL Resync: On',
            },
        ],
    };
}

export function findSchemaNodeById(schema: MenuSchema, id: string): MenuNode | undefined {
    return schema.nodes.find((n) => (n as { id?: string }).id === id);
}

export function readSchemaButtonLabel(schema: MenuSchema, id: string, fallback: string): string {
    const node = findSchemaNodeById(schema, id) as ButtonNode | undefined;
    if (!node || node.type !== 'button') {
        return fallback;
    }
    return typeof node.label === 'function' ? node.label() : node.label;
}

export function readSchemaInputPlaceholder(schema: MenuSchema, id: string, fallback: string): string {
    const node = findSchemaNodeById(schema, id) as TextInputNode | undefined;
    if (!node || node.type !== 'input') {
        return fallback;
    }
    return node.placeholder || fallback;
}

export function readSchemaTextAt(schema: MenuSchema, index: number, fallback: string): string {
    const textNodes = schema.nodes.filter((n): n is TextNode => n.type === 'text');
    const node = textNodes[index];
    if (!node) {
        return fallback;
    }
    return typeof node.text === 'function' ? node.text() : node.text;
}